import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider, SimulationProvider, UIProvider } from './contexts';
import WelcomeScreen from './components/welcome-screen';
import EmailPreview from './dev/EmailPreview';
import '@/utils/svgAssets';
import './app-frame.css';
import './App.css';

const getBasename = () => {
  if (import.meta.env.PROD) {
    return '/simulateur/app/';
  }
  return '/';
};

function App() {
  const basename = getBasename();

  return (
    <ConfigProvider>
      <SimulationProvider>
        <UIProvider>
          <div className="app-frame">
            <div className="phone-screen">
              <Router basename={basename}>
                <Routes>
                  <Route path="/" element={<WelcomeScreen />} />
                  {import.meta.env.DEV && (
                    <Route path="dev/email-preview" element={<EmailPreview />} />
                  )}
                  <Route path="*" element={<Navigate to="/" />} />
                </Routes>
              </Router>
            </div>
          </div>
        </UIProvider>
      </SimulationProvider>
    </ConfigProvider>
  );
}

export default App;
